import { Font } from "../types";

export const getFont = (font?: Font) => {
  switch (font) {
    case 'base':
      return 'var(--fontFamilyBase)'
    case 'monospace':
      return 'var(--fontFamilyMonospace)'
    case 'numeric':
      return 'var(--fontFamilyNumeric)'
    default:
      return font
  }
}